import * as action from "./types";

export const addNotification = (payload) => ({
  type: action.ADD_NOTIFICATION,
  payload,
});

export const setNotifications = (payload) => ({
  type: action.SET_NOTIFICATIONS,
  payload,
});

export const setNotificationBanner = (payload) => ({
  type: action.SET_NOTIFICATION_BANNER,
  payload,
});

export const setNotificationUserReads = (payload) => ({
  type: action.SET_NOTIFICATION_USER_READS,
  payload,
});

export const addNotificationUserRead = (payload) => ({
  type: action.ADD_NOTIFICATION_USER_READ,
  payload,
});

export const updateMarkReadPushNotifications = (payload) => ({
  type: action.UPDATE_MARK_READ_NOTIFICATIONS,
  payload,
});

export const updatePushNotificationUserAccess = (payload) => ({
  type: action.UPDATE_PUSH_NOTIFICATION_USERACCESS,
  payload,
});

export const refreshNotification = (payload)=>({
  type: action.REFRESH_NOTIFICATION,
  payload,
})

export const fetchNotification = (payload)=>({
  type: action.FETCH_NOTIFICATION,
  payload,
})

export const finishGetNotifications = (payload)=>({
  type: action.FINISH_GET_NOTIFICATIONS,
  payload
})

export const getNotifications = () => ({
  type: action.GET_NOTIFICATIONS,
  payload:[]
});

export const notification_page_read = (payload) => ({
  type: action.NOTIFICATIONS_PAGE_READ,
  payload
})
